import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Box,
  Divider,
  Typography,
  useTheme,
  Container,
  Card,
  CardActions,
  CardActionArea,
  CardContent,
  InputAdornment,
  OutlinedInput,
  SvgIcon,
  Avatar,
  Checkbox,
  Stack,
  Button,
  Popover,
  Dialog,
  AlertTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Collapse,
  Popper,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
// import { styled } from "@mui/material/styles";

import moment from "moment/moment";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
// import { mockDataInvoices } from "../../data/mockData";
import Header from "../../components/Header";
import Api from "../../constants/Api";
import axios from "../../axios";
import { authBasicHeader } from "../../service/auth-header-basic";
import {
  stateStr,
  stateColor,
  msgIdSuccessList,
  stateColorNew,
} from "../../service/function";
import { type } from "@testing-library/user-event/dist/type";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "20%" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value / 3.33333
        ).toFixed(0)}s`}</Typography>
      </Box>
    </Box>
  );
}

const Orders = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPage: "",
    previousPage: "",
    nextPage: "",
    totalcount: "",
    goToPage: "",
  });

  const [filter, setFilter] = useState({
    search: "",
  });
  const [tick, setTick] = useState(0);
  const [counter, setCounter] = useState(30);

  useEffect(() => {
    getData(pageData.currentPage, pageData.pageSize, filter.search);
  }, [pageData.currentPage, pageData.pageSize, filter.search, tick]);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    if (counter == 0) {
      setTick(tick + 1);
      // setTimeout(() => {
      //   setCounter(30);
      // }, 3000);
    }
    return () => clearInterval(timer);
  }, [counter]);

  const getData = (page, pageSize, search) => {
    (async () => {
      setIsLoading(true);
      await axios
        .get(`${Api.ORDER_STATE_LIST}`, {
          headers: authBasicHeader(),
          params: {
            search,
            page,
            skip: pageSize,
          },
        })
        .then((response) => {
          console.log("response", response);
          if (response.data.success) {
            let res = response.data;
            let data = response.data.data.result;
            setData(data);

            setPageData((old) => ({
              ...old,
              currentPage: page,
              pageSize: pageSize,
              totalcount: res.data.totalCount,
            }));
          }
          setIsLoading(false);
          setTimeout(() => {
            setCounter(30);
          }, 2000);
        })
        .catch((err) => {
          console.log("err", err);
          setNotiMsg((m) => ({
            ...m,
            type: "error",
            msg: err.message,
            header: "Error",
          }));
          setIsLoading(false);
          setNotiOpen(true);
          // responseHandleSrv.handleError(err);
        });
    })();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [notiMsg, setNotiMsg] = useState({
    type: "",
    msg: "",
    header: "",
  });
  const [open, setOpen] = useState(false);
  const [dataPending, setDataPending] = useState({
    order_id: 0,
    state: "",
  });
  const [notiOpen, setNotiOpen] = React.useState(false);

  const handleClick = (iid, event) => {
    let sp = iid.split("_");
    setAnchorEl(event.currentTarget);
    // setErrorMsg(text);
    setOpen(true);

    setDataPending((pen) => ({
      ...pen,
      order_id: parseInt(sp[0]),
      state: sp[1],
    }));
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
    setDataPending((pen) => ({
      ...pen,
      order_id: 0,
      state: "",
    }));
  };

  const handleNotiClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotiOpen(false);
  };

  const closeAlert = () => {
    const timeId = setTimeout(() => {
      // After 3 seconds set the show value to false
      setNotiOpen(false);
    }, 10000);
  };

  const textTooltip = (text) => {
    return (
      <div>
        message_id : {text.message_id}
        <br />
        message : {text.message}
      </div>
    );
  };

  const textTooltipComplete = (text, from) => {
    // console.log("textTooltipComplete text", text);
    // console.log("textTooltipComplete from", from);
    switch (from) {
      case "customer":
        return <div>code : {text.card_code}</div>;
        break;
      case "so":
        // "so_series":"2307SO","so_no":"230700021"
        return (
          <div>
            so_series : {text.so_series}
            <br />
            so_no : {text.so_no}
          </div>
        );
        break;
      case "ar":
        // "arin_series":"2307ARIN","arin_no":"23070033"
        return (
          <div>
            arin_series : {text.arin_series}
            <br />
            arin_no : {text.arin_no}
          </div>
        );
        break;
      case "delivery":
        // "do_series":"2307DO","do_no":"23070019"
        return (
          <div>
            do_series : {text.do_series}
            <br />
            do_no : {text.do_no}
          </div>
        );
        break;
      default:
        //incoming
        // "rec_series":"2311REC","rec_no":"23110001"
        return (
          <div>
            rec_series : {text.rec_series}
            <br />
            rec_no : {text.rec_no}
          </div>
        );
      // code block
    }
    // return (
    //   <div>
    //     message_id : {text.message_id}
    //     <br />
    //     message : {text.message}
    //   </div>
    // );
  };

  const updatePending = () => {
    console.log("dataPending", dataPending);
    (async () => {
      setIsLoading(true);
      await axios
        .post(`${Api.UPDATE_PENDING}`, dataPending, {
          headers: authBasicHeader(),
        })
        .then((response) => {
          console.log("updatePending", response);
          if (response.data.success) {
            setNotiMsg((m) => ({
              ...m,
              type: "success",
              msg: "Update Success",
              header: "Success",
            }));
            setNotiOpen(true);
            let newData = [...data];
            // let index = newData.findIndex((p) => p.id == dataPending.order_id);
            let find = newData.find((p) => p.id == dataPending.order_id);
            // console.log("index", index);
            console.log("find", find);
            if (find) {
              switch (dataPending.state) {
                case "customer":
                  // newData[index].customer = 0;
                  find.customer = 0;
                  break;
                case "so":
                  // newData[index].so = 0;
                  find.so = 0;
                  break;
                case "ar":
                  // newData[index].ar = 0;
                  find.ar = 0;
                  break;
                case "delivery":
                  // newData[index].delivery = 0;
                  find.delivery = 0;
                  break;
                default:
                  // newData[index].incoming = 0;
                  find.incoming = 0;
              }
              setData(newData);
            }

            handleClose();
            closeAlert();
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setNotiMsg((m) => ({
            ...m,
            type: "error",
            msg: err.message,
            header: "Error",
          }));
          setIsLoading(false);
          setNotiOpen(true);
          // responseHandleSrv.handleError(err);
        });
    })();
  };

  const checkBtn = (isCompleted, date, msg, from, id) => {
    // console.log(msg,id);
    let listMsgId = msgIdSuccessList();

    const open = Boolean(anchorEl);
    try {
      if (parseInt(isCompleted) === 1 && msg !== "") {
        
        let text = JSON.parse(msg);
        // console.log("text", text);
        let find = listMsgId.find((o) => o.name == from);
        // console.log("find", find);
        if (text.message_id !== find.id) {
          //progress error//
          return (
            <div>
              <Tooltip
                title={
                  <Typography fontSize={15} maxWidth="xs">
                    {textTooltip(text)}
                  </Typography>
                }
                arrow
              >
                <CardActionArea
                  onClick={handleClick.bind(this, id)}
                  sx={{
                    fontSize: "0.75rem",
                    fontFamily: "Source Sans Pro,sans-serif",
                  }}
                >
                  <Card
                    sx={{
                      minWidth: 150,
                      minHeight: 70,
                      color: "white",
                      textAlign: "center",
                    }}
                    variant="contained"
                    style={{
                      backgroundColor: stateColorNew[3],
                    }}
                  >
                    <div>
                      <div>{stateStr[3]}</div>
                      <div>
                        {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
                      </div>
                    </div>
                  </Card>
                </CardActionArea>
                {/* <Button
                  id={id}
                  sx={{ color: "white" }}
                  variant="contained"
                  size="small"
                  color={stateColor[3]}
                  onClick={handleClick.bind(this, id)}
                >
                  {stateStr[3]} <br />
                  {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
                </Button> */}
              </Tooltip>
            </div>
          );
        } else {
          //progress not error //
          return (
            <Card
              sx={{
                minWidth: 150,
                minHeight: 70,
                color: "white",
                textAlign: "center",
              }}
              variant="contained"
              style={{
                backgroundColor: stateColorNew[parseInt(isCompleted)],
              }}
            >
                <div>
                  <div>{stateStr[parseInt(isCompleted)]}</div>
                  {parseInt(isCompleted) === 2 && textTooltipComplete(text, from)}
                  <div>
                    {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
                  </div>
                </div>
            </Card>
            // <div>
            //   <Button
            //     sx={{ color: "white" }}
            //     variant="contained"
            //     size="small"
            //     color={stateColor[parseInt(isCompleted)]}
            //   >
            //     {stateStr[parseInt(isCompleted)]} <br />
            //     {textTooltipComplete(text, from)} <br />
            //     {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
            //   </Button>
            // </div>
          );
        }
      } else {
        //pending or success//
        let text ="";
        if(msg)
        {
           text = JSON.parse(msg);
        }
        return (
          <Card
            sx={{
              minWidth: 150,
              minHeight: 70,
              color: "white",
              textAlign: "center",
            }}
            variant="contained"
            style={{
              backgroundColor: stateColorNew[parseInt(isCompleted)],
            }}
          >
            <div>
              <div>{stateStr[parseInt(isCompleted)]}</div>
            
              {parseInt(isCompleted) === 2 && textTooltipComplete(text, from)}
              <div>
                {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
              </div>
            </div>
          </Card>
        );
      }
    } catch (error) {
      // text is null //
      if (parseInt(isCompleted) == 0) {
        // pending //
        return (
          <Card
            sx={{
              minWidth: 150,
              minHeight: 70,
              color: "white",
              textAlign: "center",
            }}
            variant="contained"
            style={{
              backgroundColor: stateColorNew[parseInt(isCompleted)],
            }}
          >
            <div>
              <div>{stateStr[parseInt(isCompleted)]}</div>
              <div>
                {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
              </div>
            </div>
          </Card>
        );
      } else {
        // text is null && not pending //
        return (
          <Tooltip
            title={
              <Typography fontSize={15} maxWidth="xs">
                {textTooltip(msg)}
              </Typography>
            }
            arrow
          >
            <CardActionArea
              onClick={handleClick.bind(this, id)}
              sx={{
                fontSize: "0.75rem",
                fontFamily: "Source Sans Pro,sans-serif",
              }}
            >
              <Card
                sx={{
                  minWidth: 150,
                  minHeight: 70,
                  color: "white",
                  textAlign: "center",
                }}
                variant="contained"
                style={{
                  backgroundColor: stateColorNew[3],
                }}
              >
                <div>
                  <div>{stateStr[3]}</div>
                  <div>
                    {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
                  </div>
                </div>
              </Card>
            </CardActionArea>
            {/* //   <Button
          //     sx={{ color: "white" }}
          //     variant="contained"
          //     size="small"
          //     color={stateColor[3]}
          //     onClick={handleClick.bind(this, id)}
          //   >
          //     {stateStr[3]} <br />
          //     {date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : ""}
          //   </Button>  */}
          </Tooltip>
        );
      }
    }
  };
  const columns = [
    {
      field: "order_number",
      // headerName: "Order No." ,
      headerAlign: "center",
      align: "center",
      width: 200,
      renderHeader: () => <strong>{"Order No."}</strong>,
      // renderCell: ({ row: { order_number } }) => {
      //   return <h2>{order_number}</h2>;
      // },
    },
    {
      field: "customer",
      headerName: "customer",
      headerAlign: "center",
      align: "center",
      renderHeader: () => <strong>{"Customer"}</strong>,
      width: 170,
      renderCell: ({ row: { customer, date_customer, res_customer, id } }) => {
        let iid = id + "_customer";
        return checkBtn(customer, date_customer, res_customer, "customer", iid);
      },
    },
    {
      field: "so",
      headerName: "so",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderHeader: () => <strong>{"SO"}</strong>,
      renderCell: ({ row: { so, date_so, res_so, id } }) => {
        let iid = id + "_so";
        return checkBtn(so, date_so, res_so, "so", iid);
      },
    },
    {
      field: "ar",
      headerName: "ar",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderHeader: () => <strong>{"AR"}</strong>,
      renderCell: ({ row: { ar, date_ar, res_ar, id } }) => {
        let iid = id + "_ar";
        return checkBtn(ar, date_ar, res_ar, "ar", iid);
      },
    },
    {
      field: "delivery",
      headerName: "delivery",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderHeader: () => <strong>{"Delivery"}</strong>,
      renderCell: ({ row: { delivery, date_delivery, res_delivery, id } }) => {
        let iid = id + "_delivery";
        return checkBtn(delivery, date_delivery, res_delivery, "delivery", iid);
      },
    },
    {
      field: "incoming",
      headerName: "incoming",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderHeader: () => <strong>{"Incoming"}</strong>,
      renderCell: ({ row: { incoming, date_incoming, res_incoming, id } }) => {
        let iid = id + "_incoming";
        return checkBtn(incoming, date_incoming, res_incoming, "incoming", iid);
      },
    },
  ];
  const keyPress = (e) => {
    if (e.keyCode == 13) {
      // console.log("value", e.target.value);
      setFilter((old) => ({ ...old, search: e.target.value }));
    }
  };

  return (
    <Box m="20px">
      <Snackbar
        sx={{ width: "30%" }}
        open={notiOpen}
        autoHideDuration={10000}
        onClose={handleNotiClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleNotiClose}
          severity={notiMsg.type}
          sx={{ width: "100%" }}
        >
          <AlertTitle>{notiMsg.header}</AlertTitle>
          {notiMsg.msg}
        </Alert>
      </Snackbar>
      {/* <Snackbar
        sx={{ width: "30%" }}
        open={isLoading}
        autoHideDuration={10000}
        // onClose={handleNotiClose}
        anchorOrigin={{ vertical: "buttom", horizontal: "right" }}
      >
        <CircularProgress disableShrink />
      </Snackbar> */}
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px", // Set your width here
              // boxShadow: 'none'
            },
          },
          // "& .css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop": {
          //   backgroundColor: "transparent",
          // },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <Divider /> */}
        <DialogTitle id="alert-dialog-title">{"เกิดข้อผิดพลาด!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              *กรุณาตรวจสอบข้อมูล และแก้ไขให้ถูกต้อง ก่อนกดยืนยัน เพื่อทำการ
              update ข้อมูล*
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleClose}>
            ยกเลิก
          </Button>
          <Button
            color="primary"
            onClick={updatePending}
            disableRestoreFocus={true}
            autoFocus
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="ORDER STATE" subtitle="welcome to you Order State" />
      </Box>
      <Box>
        <Card sx={{ p: 2 }}>
          {/* <Grid container columnSpacing={2}> */}
          {/* <Grid item xs={12} sm={6}> */}
          <OutlinedInput
            defaultValue=""
            fullWidth
            placeholder="Search order"
            onKeyDown={keyPress}
            startAdornment={
              <InputAdornment position="start">
                <SvgIcon color="action" fontSize="small">
                  {/* <MagnifyingGlassIcon /> */}
                </SvgIcon>
              </InputAdornment>
            }
            sx={{ maxWidth: 500 }}
          />
          {/* </Grid> */}
          {/* </Grid> */}
        </Card>
      </Box>
      <Box
        m="8px 0 0 0"
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.primary[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            // backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            // backgroundColor: colors.primary[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiChackbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        {/* {console.log(pageData.totalcount)} */}

        <DataGrid
          // autoHeight

          rows={data}
          rowCount={pageData.totalcount}
          // loading={isLoading}
          rowsPerPageOptions={[10, 30, 50, 70, 100]}
          pagination
          page={pageData.currentPage - 1}
          pageSize={pageData.pageSize}
          paginationMode="server"
          onPageChange={(newPage) => {
            setPageData((old) => ({ ...old, currentPage: newPage + 1 }));
          }}
          onPageSizeChange={(newPageSize) => {
            setPageData((old) => ({ ...old, pageSize: newPageSize }));
          }}
          columns={columns}
          getRowHeight={({ id, densityFactor }) => {
            return 90 * densityFactor;
          }}
        />
      </Box>

      <Grid container justifyContent="flex-end">
        <LinearProgressWithLabel value={counter * 3.33333} />
      </Grid>
    </Box>
  );
};

export default Orders;
